<template>
    <div>
      <CRow class="mb-3 search-panel">
        <CCol xs="12" sm="6" md="6" lg="6" xl="2">
          <BaseInput :options="titleInput.options" :data="titleInput.data" :listener="titleInput.listener" />
        </CCol>
        <CCol>
          <div class="form-group">
            <label style="color: white"></label>
            <div style="margin-top: 10px">
              <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
                v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
                <i class="fa fa-refresh"></i>&nbsp;Tải lại
              </CButton>
              <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
                v-c-tooltip.hover="'Thêm mới'" class="btn-action-primary"
                @click="openPoupUpdate()">
                <i class="fa fa-plus"></i>&nbsp;Thêm mới
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
      <CRow class="row-2">
  
      </CRow>
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
            ref="mainTable">
            <template #index="{ index }">
              <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
            </template>

            <template #createDate="{ item }">
              <td v-if="item.createDate != null">
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
              <td v-else></td>
            </template>
  
            <template #isActive="{ item }">
              <td v-if="item.isActive == true">
                <span class="dot-custom dot-success">
                  Hoạt động
                  <BaseSwitch class="mx-1" color="success" checked variant="3d" v-bind="labelIcon"
                    @update:checked="setupSelectOneAction('update_active', item.id, item.name, item.isActive)" />
                </span>
              </td>
  
              <td v-else>
                <span class="dot-custom dot-danger">
                  Không hoạt động
                  <BaseSwitch class="mx-1" color="danger" variant="3d" v-bind="labelIcon"
                    @update:checked="setupSelectOneAction('update_active', item.id, item.name, item.isActive)" />
                </span>
              </td>
            </template>
  
            <template #action="{ item }">
              <td class="action-btn-group">
                <div class="action-btn-wrapper">
                  <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="info" variant="outline"
                    v-c-tooltip.hover="'Cập nhật thông tin'" square size="sm" @click="loadDataById(item.id)">
                    <i class="fa fa-eye" />
                  </CButton>
                  <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="info" variant="outline"
                    v-c-tooltip.hover="'Cập nhật thông tin xác thực'" square size="sm" @click="openPoupUpdateCert(item.id)">
                    <i class="fa fa-lock" />
                  </CButton>
                  <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="info" variant="outline" v-c-tooltip.hover="'Cấu hình thông tin TTS'"
                    square size="sm" @click="$router.push(`/administrator/${item.id}/config-text-to-form.html`)">
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="danger" variant="outline" square size="sm"
                    v-c-tooltip.hover="'Xóa'" @click="setupSelectOneAction('delete_one', item.id, item.name)">
                    <CIcon name="cil-trash" />
                  </CButton>
                </div>
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>

      <CModal :title="'Cập nhật TTS'" :show.sync="isShowModal" :closeOnBackdrop="false">
        <CRow class="pb-2">
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSave.valueInput.options" :data="dataSave.valueInput.data"
              :listener="dataSave.valueInput.listener" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSave.nameInput.options" :data="dataSave.nameInput.data"
              :listener="dataSave.nameInput.listener" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSave.limitText.options" :data="dataSave.limitText.data"
              :listener="dataSave.limitText.listener" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseSelect :options="dataSave.levelLocationSelect.options" :data="dataSave.levelLocationSelect.data" ref="levelLocationSelect">
            </BaseSelect>
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseSelect :options="dataSave.locationSelect.options" :data="dataSave.locationSelect.data" ref="locationSelect">
            </BaseSelect>
          </CCol>
        </CRow>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
          </button>
          <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa fa-save"></i>
            Lưu lại
          </button>
        </template>
      </CModal>


      <CModal :title="'Cập nhật TTS'" :show.sync="isShowModalCert" :closeOnBackdrop="false">
        <CRow class="pb-2">
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSaveCert.urlApiInput.options" :data="dataSaveCert.urlApiInput.data"
              :listener="dataSaveCert.urlApiInput.listener" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSaveCert.keyApiInput.options" :data="dataSaveCert.keyApiInput.data"
              :listener="dataSaveCert.keyApiInput.listener" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSaveCert.tokenIdInput.options" :data="dataSaveCert.tokenIdInput.data"
              :listener="dataSaveCert.tokenIdInput.listener" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSaveCert.tokenKeyInput.options" :data="dataSaveCert.tokenKeyInput.data"
              :listener="dataSaveCert.tokenKeyInput.listener" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSaveCert.accessTokenInput.options" :data="dataSaveCert.accessTokenInput.data"
              :listener="dataSaveCert.accessTokenInput.listener" />
          </CCol>
        </CRow>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="isShowModalCert = false"><i class="fa fa-times"></i> Hủy bỏ
          </button>
          <button type="button" class="btn btn-primary" @click="submitDataCert()"><i class="fa fa-save"></i>
            Lưu lại
          </button>
        </template>
      </CModal>
  
      <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
  
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  
  
    </div>
  </template>
  
  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  import BaseModal from "@/views/base/BaseModal";
  import BaseSwitch from "@/views/base/BaseSwitch";
  
  export default {
    name: "ConfigTextToSpeechList",
    components: {
      BaseFormLoading,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      BaseModal,
      BaseSwitch
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
      showErrorMsg: {
        type: "error",
        title: "Error",
      },
      showWarningMsg: {
        type: "warn",
        title: "warn",
      },
    },
    data() {
      let that = this;
      let actionTypeMapping = new Map();
      actionTypeMapping.set("delete_one", {
        url: "/text-to-speech-config/deleteById",
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "xóa",
            "cấu hình",
            that.actionData.model.configName
          );
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            id: that.actionData.model.configId
          };
        },
        successCallback: function () {
          that.showSuccessMsg({ message: "Xóa cấu hình " + that.actionData.model.configName + " thành công" });
          that.loadDataMainTable();
        }
      });
      actionTypeMapping.set("update_active", {
        url: "/text-to-speech-config/update-active",
        titlePopup: function () {
          return that.$helper.setupTitleAction(that.actionData.model.isSync == true ? "tắt hoạt động" : "mở hoạt động", "cấu hình", that.actionData.model.configName);
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            id: that.actionData.model.configId
          };
        },
        successCallback: function () {
          that.showSuccessMsg({ message: that.actionData.model.userIsEnable == true ? "Tắt hoạt động thành công" : "Mở hoạt động thành công" });
          that.loadDataMainTable();
        },
      });
      return {
        labelIcon: {
          labelOn: '\u2713',
          labelOff: '\u2715'
        },
        isShowModal: false,
        isShowModalCert: false,
        isSelectedAllDevices: false,
        loading: {
          value: false,
        },
        dataSaveCert: {
          idField: {
            data: {
              name: "id",
              model: ""
            }
          },
          urlApiInput: {
            options: {
              label: "API",
              placeholder: "API",
            },
            data: {
              name: "urlApi",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              }
            }
          },
          keyApiInput: {
            options: {
              label: "Key API",
              placeholder: "Key API",
            },
            data: {
              name: "keyApi",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              }
            }
          },
          tokenIdInput: {
            options: {
              label: "Token Id",
              placeholder: "Token Id",
            },
            data: {
              name: "tokenId",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              }
            }
          },
          tokenKeyInput: {
            options: {
              label: "Token Key",
              placeholder: "Token Key",
            },
            data: {
              name: "tokenKey",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              }
            }
          },
          accessTokenInput: {
            options: {
              label: "Access token",
              placeholder: "Access token",
            },
            data: {
              name: "accessToken",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              }
            }
          },
        },
        dataSave: {
          idField: {
            data: {
              name: "id",
              model: ""
            }
          },
          valueInput: {
            options: {
              label: "Giá trị <span class='required'>*</span>",
              placeholder: "Giá trị",
            },
            data: {
              name: "value",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataSave.valueInput.data.model;
                  if (value === "") {
                    this.isValid = false;
                    this.errorMessage = "Giá trị không được để trống";
                  } else if (value.length > 64) {
                    this.isValid = false;
                    this.errorMessage = "Giá trị được quá 64 kí tự";
                  } else {
                    this.isValid = true;
                  }
                  return this.isValid;
                }
              }
            }
          },
          nameInput: {
            options: {
              label: "Tên cấu hình <span class='required'>*</span>",
              placeholder: "Tên cấu hình",
            },
            data: {
              name: "name",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataSave.nameInput.data.model;
                  if (value === "") {
                    this.isValid = false;
                    this.errorMessage = "Tên cấu hình không được để trống";
                  } else if (value.length > 256) {
                    this.isValid = false;
                    this.errorMessage = "Tên cấu hình được quá 256 kí tự";
                  } else {
                    this.isValid = true;
                  }
                  return this.isValid;
                }
              }
            }
          },
          limitText: {
            options: {
              label: "Ký tự tối đa 1 lần dịch <span class='required'>*</span>",
              placeholder: "Ký tự tối đa 1 lần dịch",
              type: 'number'
            },
            data: {
              name: "limitText",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataSave.limitText.data.model;
                  if (value === "") {
                    this.isValid = false;
                    this.errorMessage = "Ký tự tối đa 1 lần dịch không được để trống";
                  } else {
                    this.isValid = true;
                  }
                  return this.isValid;
                }
              }
            }
          },
          levelLocationSelect: {
            options: {
              label: "Cấp địa bàn",
              filter: false,
              selectAllText: "Chọn cấp địa bàn",
              'keyField': 'key',
              'valueField': 'value',
            },
            data: {
              model: null,
              name: "locationLevel",
              items: [
                { key: "0", value: "Tỉnh/Thành phố" },
                { key: "1", value: "Quận/Huyện" },
                { key: "2", value: "Phường/Xã" },
              ],
           }
          },
          locationSelect: {
            options: {
              lazyLoad: true,
              label: "Địa phương sử dụng",
              selectAllText: "Chọn địa phương",
              'keyField': 'key',
              'valueField': 'value',
              disabled: true,
            },
            data: {
              model: "",
              name: 'locationCode',
              items: [],
              source: {
                url: "/common/findAllLocationByLevel",
                isJsonContentType: false,
                dataSubmit() {
                  return {
                    level: that.dataSave.levelLocationSelect.data.model == null ? 0 : that.dataSave.levelLocationSelect.data.model,
                  }
                },
                response: function (dataResponse) {
                  that.dataSave.locationSelect.data.items = dataResponse.data
                }
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              },
            }
          },
        },
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            selectedAll: false,
            configId: null,
            configName: null
          }
        },
        titleInput: {
          options: {
            placeholder: "Tên cấu hình",
            label: "Tên cấu hình",
          },
          data: {
            name: "name",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        mainTable: {
          options: {
            fields: [
              { key: "index", label: "STT", sorter: false, filter: false },
              { key: "createDate", label: "Ngày tạo" },
              { key: "value", label: "Giá trị" },
              { key: "name", label: "Tên" },
              { key: "location", label: "Địa bàn" },
              { key: "isActive", label: "Trạng thái" },
              { key: "action", label: "Thao tác", _classes: "action-sticky-group", _style: "", sorter: false, filter: false },
            ],
            slots: [
              "index", "createDate", "isActive", "action"
            ],
            pageSize: 20,
            sorter: true,
            columnFilter: false,
            itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
            tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
          },
          dataSource: {
            url: "/text-to-speech-config/getPages",
            dataSubmit: function () {
              var params = that.$helper.setupDataSubmit(that.$data);
              return params;
            },
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
        },
      };
    },
    methods: {
      loadDataMainTable: function (isUpdateFilter) {
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      setupSelectOneAction: function (actionTypeKey, configId, configName, isSync) {
        let actionData = this.actionData.model;
        actionData.configId = configId || null;
        actionData.configName = configName || null;
        actionData.isSync = isSync
        this.$refs.actionModal.setCurrAction(actionTypeKey);
      },
      loadDataById(id) {
        let that = this;
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/text-to-speech-config/find-by-id",
          isJsonContentType: false,
          dataSubmit: function () {
            return {id: id}
          },
          successCallback: function (response) {
            that.isShowModal = true;
            that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },
  
      openPoupUpdate: function () {
        this.dataSave.idField.data.model = null;
        this.dataSave.valueInput.data.model = "";
        this.dataSave.nameInput.data.model = "";
        this.isShowModal = true;
      },

      openPoupUpdateCert: function (id) {
        this.dataSaveCert.idField.data.model = id;
        this.dataSaveCert.urlApiInput.data.model = "";
        this.dataSaveCert.keyApiInput.data.model = "";
        this.dataSaveCert.tokenIdInput.data.model = "";
        this.dataSaveCert.tokenKeyInput.data.model = "";
        this.dataSaveCert.accessTokenInput.data.model = "";
        this.isShowModalCert = true;
      },
  
      submitData: function () {
        let that = this;
        let isValid = true;
        isValid &= this.dataSave.valueInput.data.validator.valid();
        isValid &= this.dataSave.nameInput.data.validator.valid();
        if (!isValid) {
          return;
        }
        let dataRequest = {
          id: this.dataSave.idField.data.model,
          value: this.dataSave.valueInput.data.model,
          name: this.dataSave.nameInput.data.model,
          limitText: this.dataSave.limitText.data.model,
          levelLocation: this.dataSave.levelLocationSelect.data.model,
          locationCode: this.dataSave.locationSelect.data.model,
        }
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/text-to-speech-config/update",
          dataSubmit: function () {
            return dataRequest;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({
                message: "Cập nhật cấu hình thành công"
              });
              that.isShowModal = false;
              that.loadDataMainTable();
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },


      submitDataCert: function () {
        let that = this;
        let isValid = true;
        if (!isValid) {
          return;
        }
        let dataRequest = {
          id: this.dataSaveCert.idField.data.model,
          urlApi: this.dataSaveCert.urlApiInput.data.model,
          keyApi: this.dataSaveCert.keyApiInput.data.model,
          tokenId: this.dataSaveCert.tokenIdInput.data.model,
          tokenKey: this.dataSaveCert.tokenKeyInput.data.model,
          accessToken: this.dataSaveCert.accessTokenInput.data.model,
        }
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/text-to-speech-config/update-cert",
          dataSubmit: function () {
            return dataRequest;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({
                message: "Cập nhật thông tin xác thực cấu hình thành công"
              });
              that.isShowModalCert = false;
              that.loadDataMainTable();
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
      'dataSave.levelLocationSelect.data.model': function (value) {
        if (value != 0) {
          this.$refs.locationSelect.loadData();
          this.dataSave.locationSelect.options.disabled = false;
        } else {
          this.dataSave.locationSelect.data.items = [];
          this.dataSave.locationSelect.options.disabled = true;
        }
      },
    },
    computed: {},
  };
  </script>
  <style scoped>
  .td-roles {
    max-width: 250px;
  }
  </style>
  <style>
  .row-2 .form-group {
    margin-top: 0 !important;
  }
  </style>